export const mixedOptions = [
  { label: 'Domestic Longhair', value: 'Domestic Longhair' },
  { label: 'Domestic Mediumhair', value: 'Domestic Mediumhair' },
  { label: 'Domestic Shorthair', value: 'Domestic Shorthair' },
  { label: 'Mixed Breed', value: 'Mixed Breed' },
];

export const breedOptions = [
  { value: 'Abyssinian', label: 'Abyssinian' },
  { value: 'American Bobtail', label: 'American Bobtail' },
  { value: 'American Curl', label: 'American Curl' },
  { value: 'American Curl Shorthair', label: 'American Curl Shorthair' },
  { value: 'American Keuda', label: 'American Keuda' },
  { value: 'American Longhair', label: 'American Longhair' },
  {
    value: 'American Shorthair (purebred)',
    label: 'American Shorthair (purebred)',
  },
  { value: 'American Wirehair', label: 'American Wirehair' },
  { value: 'Angora', label: 'Angora' },
  { value: 'Australian Mist', label: 'Australian Mist' },
  { value: 'Balinese', label: 'Balinese' },
  { value: 'Bengal', label: 'Bengal' },
  { value: 'Bengalese', label: 'Bengalese' },
  { value: 'Birman', label: 'Birman' },
  { value: 'Bombay', label: 'Bombay' },
  { value: 'Brazilian Shorthair', label: 'Brazilian Shorthair' },
  { value: 'British Shorthair', label: 'British Shorthair' },
  { value: 'Burmese', label: 'Burmese' },
  { value: 'Burmilla', label: 'Burmilla' },
  { value: 'California Spangled Cat', label: 'California Spangled Cat' },
  { value: 'Cameo Longhair', label: 'Cameo Longhair' },
  { value: 'Chantilly/Tiffany', label: 'Chantilly/Tiffany' },
  { value: 'Chartreux', label: 'Chartreux' },
  { value: 'Chausie', label: 'Chausie' },
  { value: 'Chinchilla', label: 'Chinchilla' },
  { value: 'Colorpoint', label: 'Colorpoint' },
  { value: 'Colorpoint Longhair', label: 'Colorpoint Longhair' },
  { value: 'Colorpoint Shorthair', label: 'Colorpoint Shorthair' },
  { value: 'Cornish Rex', label: 'Cornish Rex' },
  { value: 'Cymric', label: 'Cymric' },
  { value: 'Devon Rex', label: 'Devon Rex' },
  { value: 'Egyptian Mau', label: 'Egyptian Mau' },
  { value: 'European Burmese', label: 'European Burmese' },
  { value: 'European Shorthair', label: 'European Shorthair' },
  { value: 'Exotic', label: 'Exotic' },
  { value: 'Exotic Longhair', label: 'Exotic Longhair' },
  { value: 'Exotic Shorthair', label: 'Exotic Shorthair' },
  { value: 'Feral', label: 'Feral' },
  { value: 'German Rex', label: 'German Rex' },
  { value: 'Havana Brown', label: 'Havana Brown' },
  { value: 'Highland Fold', label: 'Highland Fold' },
  { value: 'Highland Lynx', label: 'Highland Lynx' },
  { value: 'Himalayan', label: 'Himalayan' },
  { value: 'Himalayan Blue Point', label: 'Himalayan Blue Point' },
  { value: 'Himalayan Flame Point', label: 'Himalayan Flame Point' },
  { value: 'Himalayan Lilac Point', label: 'Himalayan Lilac Point' },
  { value: 'Himalayan Seal Point', label: 'Himalayan Seal Point' },
  { value: 'Japanese Bobtail', label: 'Japanese Bobtail' },
  { value: 'Javanese', label: 'Javanese' },
  { value: 'Kashmir', label: 'Kashmir' },
  { value: 'Korat', label: 'Korat' },
  { value: 'La Perm', label: 'La Perm' },
  { value: 'Maine Coon', label: 'Maine Coon' },
  { value: 'Manx', label: 'Manx' },
  { value: 'Manx Longhair', label: 'Manx Longhair' },
  { value: 'Munchkin', label: 'Munchkin' },
  { value: 'Nebelung', label: 'Nebelung' },
  { value: 'Nibelung', label: 'Nibelung' },
  { value: 'Norwegian Forest Cat', label: 'Norwegian Forest Cat' },
  { value: 'Ocicat', label: 'Ocicat' },
  { value: 'Oriental', label: 'Oriental' },
  { value: 'Oriental Colorpoint', label: 'Oriental Colorpoint' },
  { value: 'Oriental Longhair', label: 'Oriental Longhair' },
  { value: 'Oriental Shorthair', label: 'Oriental Shorthair' },
  { value: 'Persian', label: 'Persian' },
  { value: 'Peterbald', label: 'Peterbald' },
  { value: 'Pinto', label: 'Pinto' },
  { value: 'Pixie-Bob', label: 'Pixie-Bob' },
  { value: 'RagaMuffin', label: 'RagaMuffin' },
  { value: 'Ragdoll', label: 'Ragdoll' },
  { value: 'Russian Blue', label: 'Russian Blue' },
  { value: 'Safari Cat', label: 'Safari Cat' },
  { value: 'Savannah', label: 'Savannah' },
  { value: 'Scotish Fold', label: 'Scotish Fold' },
  { value: 'Scottish Fold Longhair', label: 'Scottish Fold Longhair' },
  { value: 'Selkirk Rex', label: 'Selkirk Rex' },
  { value: 'Selkirk Rex Longhair', label: 'Selkirk Rex Longhair' },
  { value: 'Seychellois', label: 'Seychellois' },
  { value: 'Siamese', label: 'Siamese' },
  { value: 'Siberian', label: 'Siberian' },
  { value: 'Singapura', label: 'Singapura' },
  { value: 'Snowshoe', label: 'Snowshoe' },
  { value: 'Sokoke', label: 'Sokoke' },
  { value: 'Somali', label: 'Somali' },
  { value: 'Sphynx', label: 'Sphynx' },
  { value: 'Sterling', label: 'Sterling' },
  { value: 'Tiffanie', label: 'Tiffanie' },
  { value: 'Tonkinese', label: 'Tonkinese' },
  { value: 'Turkish Angora', label: 'Turkish Angora' },
  { value: 'Turkish Van', label: 'Turkish Van' },
  { value: 'York Chocolate', label: 'York Chocolate' },
];

export const groupedOptions = [
  {
    label: 'Mixed Breeds',
    options: mixedOptions,
  },

  { label: 'Breeds', options: breedOptions },
];
